import { getTranslation, Lang } from "@/data/translation";
import { ChipBasicInfo } from "@/services/13f/chip-basic-info";
import { ChartData } from "chart.js";

export const extractCapitalFlowData = ({
  lang,
  data,
}: {
  lang: Lang;
  data: ChipBasicInfo;
}): ChartData<"bar"> => {
  const { t } = getTranslation({ lang });
  const newData = Array.isArray(data) ? [...data] : [data];
  return {
    labels: newData.map((item) => item.date),
    datasets: [
      {
        label: t.chip.cashSurplus,
        data: newData.map((item) => item.cashSurplus ?? 0),
        backgroundColor: "#0584C7",
        borderColor: "#0584C7",
      },
    ],
  };
};
